import { FieldProps } from "formik";
import _ from "lodash";
import { useCallback } from "react";
import * as React from "react";
import { Checkbox } from "@/components/ui/checkbox"; // Import your Checkbox component

interface FormikCheckboxComponentProps {
    formikField: FieldProps;
    label?: React.ReactNode;
    onChange?: (checked: boolean) => void;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
}

const FormCheckbox = (props: FormikCheckboxComponentProps) => {
    const { formikField, onChange, onBlur, label, ...otherProps } = props;
    const { field, form } = formikField;
    const { name, value } = field;
    const { setFieldTouched, touched, handleBlur, errors, setFieldValue } = form;

    const hasError = _.get(touched, name) && !!_.get(errors, name);

    const handleCheckboxChange = useCallback(
        (checked: boolean) => {
            setFieldValue(name, checked);
            setFieldTouched(name);
            if (onChange) {
                onChange(checked);
            }
        },
        [setFieldValue, setFieldTouched, name, onChange]
    );

    const handleCheckboxBlur = useCallback((event:any) => {
        handleBlur(name);
        setFieldTouched(name);
        if (onBlur) {
            onBlur(event);
        }
    }, [name, handleBlur, setFieldTouched, onBlur]);


    return (
        <Checkbox
            id={name}
            label={label}
            checked={value}
            onCheckedChange={handleCheckboxChange}
            onBlur={handleCheckboxBlur}
            hasError={hasError}
            errorMessage={hasError && (_.get(errors, name))}
            {...otherProps}
        />
    );
};

export default FormCheckbox;
